import type { TeacherVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveTeacherProfile = createApiThunk<TeacherVM, void>(
  "teachers/retrieveTeacherProfile",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.profile();
  },
);
